/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import StudentListReservationView from "./StudentListReservationView/StudentListReservationView";
import ReservationMainView from "./ReservationMainView/ReservationMainView";
import { RESOURCES_CONSTANTS } from "config/constants";

const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;

const ReservationData = ({ 
    loadingRequest,
    data, updateActivityPopup
}) => {
    //#region States
    const [viewIdx, setViewIdx] = useState(0);
    //#endregion
    useEffect(() => {
        updateActivityPopup.adjustPopupPosition();
    }, [viewIdx]);
    //#region Functions
    const changeToListStudentReservationView = () => {
        setViewIdx(1);
    }
    //#endregion
    const isGroupRoom = data.resource.type.id === RESOURCE_TYPES_IDS.GROUP_ROOM;
    const views = [
        <ReservationMainView 
            data={data}
            isGroupRoom={isGroupRoom}
            changeToListStudentReservationView={changeToListStudentReservationView}
            setMustConfirm={updateActivityPopup.mustConfirm.set}/>,
        (!data.isManual || isGroupRoom) && 
        <StudentListReservationView 
            reservation={{
                id: data.id,
                finalized: data.finalized,
                student: data.student,
                resource: data.resource,
                penalizeData: data.penalizeData
            }}
            adjustPopupPosition={updateActivityPopup.adjustPopupPosition}
            reloadData={data.reloadData}
            loadingRequest={loadingRequest}
            setMustConfirm={updateActivityPopup.mustConfirm.set}/>
    ];
    return views[viewIdx];
}

export default ReservationData;